import { render, staticRenderFns } from "./TheList.vue?vue&type=template&id=95093eac&scoped=true"
import script from "./TheList.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TheList.vue?vue&type=style&index=0&id=95093eac&prod&lang=less"
import style1 from "./TheList.vue?vue&type=style&index=1&id=95093eac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95093eac",
  null
  
)

export default component.exports